import React, { useState, useRef } from "react";
import { Popover, PopoverContent, PopoverTrigger, Divider, Button, Flex, Icon, Text } from "@chakra-ui/react";
import { PropertyDropdownProps } from "../property/Property.types";
import PropertyForm from "../property/PropertyForm";
import { BsFillPenFill, BsFillTrash2Fill, BsFront } from "react-icons/bs";

export default function PropertyDropdown({ 
    children,
    property,
    onDelete,
    onChange,
    onDuplicate,
    isOpen,
    onClose
}: PropertyDropdownProps & { isOpen?: boolean; onClose?: () => void }) {
    const [isPropertyTypeSelectView, setIsPropertyTypeSelectView] = useState<boolean>(false)
    const initialFocusRef = useRef(null);

    return (
        <Popover 
            initialFocusRef={initialFocusRef}
            isOpen={isOpen}
            onClose={onClose}
            closeOnBlur={isOpen}
        >
            <PopoverTrigger>{children}</PopoverTrigger>
            <PopoverContent 
                width="fit-content" 
                minWidth='210px' 
                padding='0rem 0.5rem' 
                height={isPropertyTypeSelectView ? '246px' : 'auto'} 
                overflow='scroll'
                paddingBottom={'0'}
            >
                {isPropertyTypeSelectView ? (
                    <PropertyForm 
                        onRef={initialFocusRef}
                        onChange={onChange!} 
                        property={property!} 
                        onClose={onClose!}
                        onToggleView={() => setIsPropertyTypeSelectView(false)} 
                    />
                ) : (
                   <>
                        <Flex 
                            onClick={() => setIsPropertyTypeSelectView(true)} 
                            paddingInlineStart="0.5rem"
                            paddingInlineEnd="1rem"
                            className="pointer"
                            alignItems='center'
                            paddingTop="0.5rem"
                            paddingBottom="0.5rem"
                        >
                            <Icon as={BsFillPenFill} size={'sm'} fontWeight={'normal'} color='gray.500' marginRight={'1.5'} />
                            <Text fontWeight={'normal'}>Edit property</Text>
                        </Flex>
                        {property && (
                            <>
                                <Divider borderColor="gray.100" />
                                <Button 
                                    leftIcon={<BsFront />} 
                                    colorScheme='teal' 
                                    variant='ghost'
                                    width='100%'
                                    fontWeight={'normal'}
                                    justifyContent='flex-start'
                                    paddingLeft="0.5rem"
                                    paddingTop="1rem"
                                    paddingBottom="1rem"
                                    padding-right="0.5rem"
                                    size={'sm'}
                                    paddingInlineStart="1rem"
                                    paddingInlineEnd="1rem"
                                    onClick={() => { onDuplicate && onDuplicate(); onClose!() }}
                                >
                                    Duplicate
                                </Button>
                                <Divider borderColor="gray.100" />
                                <Button 
                                    leftIcon={<BsFillTrash2Fill />} 
                                    colorScheme='red' 
                                    variant='ghost'
                                    width='100%'
                                    fontWeight={'normal'}
                                    justifyContent='flex-start'
                                    paddingLeft="0.5rem"
                                    paddingTop="1rem"
                                    paddingBottom="1rem"
                                    padding-right="0.5rem"
                                    size={'sm'}
                                    paddingInlineStart="1rem"
                                    paddingInlineEnd="1rem"
                                    onClick={() => { onDelete && onDelete(); onClose!() }}
                                >
                                    Delete
                                </Button>
                            </>
                        )}
                   </>
                )}
            </PopoverContent>
      </Popover>
    )
}